var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { DataCloudSource } from "./DataCloudSource";
import { isAwsStorage, isAzureStorage, isGcpStorage, isSfStorage, isUploadStorage, } from "@biggeo/bg-utils";
export const DataCloudSourceWrapper = (_a) => {
    var { cloudInfo } = _a, props = __rest(_a, ["cloudInfo"]);
    const storageType = cloudInfo === null || cloudInfo === void 0 ? void 0 : cloudInfo.cloudStorageType;
    return (React.createElement(DataCloudSource, Object.assign({}, props, { disableHover: !cloudInfo, storageType: storageType, aws: cloudInfo && isAwsStorage(cloudInfo)
            ? {
                bucketName: cloudInfo.info.bucketName || undefined,
                storage: cloudInfo.info.storage || undefined,
            }
            : undefined, azure: cloudInfo && isAzureStorage(cloudInfo)
            ? {
                accountName: cloudInfo.info.accountName || undefined,
                containerName: cloudInfo.info.containerName || undefined,
                blobName: cloudInfo.info.blobName || undefined,
            }
            : undefined, sf: cloudInfo && isSfStorage(cloudInfo)
            ? {
                accountId: cloudInfo.info.accountId || undefined,
            }
            : undefined, gcp: cloudInfo && isGcpStorage(cloudInfo)
            ? {
                gcpBucketName: cloudInfo.info.gcpBucketName,
                projectId: cloudInfo.info.projectId || undefined,
            }
            : undefined, upload: cloudInfo && isUploadStorage(cloudInfo)
            ? {
                url: cloudInfo.info.url || undefined,
            }
            : undefined })));
};
//# sourceMappingURL=DataCloudSourceWrapper.js.map